import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import RangePlugin from "flatpickr/dist/plugins/rangePlugin"
import { French } from "flatpickr/dist/l10n/fr.js"
import { German } from "flatpickr/dist/l10n/de.js"
import { Polish } from "flatpickr/dist/l10n/pl.js"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import { Czech } from "flatpickr/dist/l10n/cs.js"
import { Slovak } from "flatpickr/dist/l10n/sk.js"
import { Ukrainian } from "flatpickr/dist/l10n/uk.js"
const debounce = require("lodash/debounce")

const datepickerLocales = {
  cs: Czech,
  de: German,
  es: Spanish,
  fr: French,
  pl: Polish,
  sk: Slovak,
  uk: Ukrainian,
}
export default class extends Controller {
  static values = {
    format: { type: String, default: "Y-m-d" },
    locale: { type: String, default: "pl" },
    range: { type: Boolean, default: false },
    enableTime: { type: Boolean, default: false },
    endInput: String
  }

  connect() {
    console.log("picker")

    const options = {
      locale: {
        ...this.locale,
        firstDayOfWeek: 1
      },
      dateFormat: this.formatValue,
      allowInput: true
    }

    if (this.enableTimeValue) {
      options.enableTime = true
      options.time_24hr = true
    }

    if (this.rangeValue) {
      options.plugins = [new RangePlugin({ input: this.endInputValue })]
    }

    this.picker = flatpickr(this.element, options)

    const handleInput = debounce(() => {
      const val = this.element.value.trim()
      try {
        const parsed = this.picker.parseDate(val, this.formatValue)

        if (parsed instanceof Date && !isNaN(parsed)) {
          const formatted = this.picker.formatDate(parsed, this.formatValue)
          if (val === formatted) {
            this.picker.setDate(parsed, true)
          }
        }
      } catch (_err) {
      }
    }, 500)

    this.element.addEventListener("keyup", handleInput)
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy()
      this.picker = null
    }
  }

  get locale() {
    if (this.hasLocaleValue) {
      return datepickerLocales[this.localeValue] || {}
    }

    return null
  }
}
